import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset scroll on route change AND on initial load/reload (fixes mobile starting mid-page)
export default function ScrollToTop() {
  const { pathname } = useLocation();

  // Disable browser scroll restoration once
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const toTop = () => {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    };
    toTop();
    // Also after full load (images/video can shift layout on mobile)
    window.addEventListener("load", toTop);
    return () => window.removeEventListener("load", toTop);
  }, []);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
